import {
  getToken,
  onMessage,
  type MessagePayload,
} from "firebase/messaging";

import { getFirebaseMessaging } from "./firebase";

// CRA reads build-time env via process.env.REACT_APP_*. Set REACT_APP_FIREBASE_VAPID_KEY
// to the project's Web Push certificate key (Firebase Console → Cloud Messaging).
const VAPID_KEY = "BD9tdPk7-4HdP4uXepXhGRI3TB65n0QyOhLM-YQEBQPrc5HPOaY--61Xe-sNgQ8lpzN_ABwaV07VWQoIHNGiFLU";

export const requestNotificationPermission = async (): Promise<boolean> => {
  if (!("Notification" in window)) {
    console.warn("Browser notifications are not supported.");
    return false;
  }

  const permission = await Notification.requestPermission();

  return permission === "granted";
};

export const registerFirebaseServiceWorker =
  async (): Promise<ServiceWorkerRegistration | null> => {
    if (!("serviceWorker" in navigator)) {
      console.warn("Service workers are not supported.");
      return null;
    }

    try {
      const registration =
        await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );

      console.log(
        "Firebase service worker registered:",
        registration.scope
      );

      return registration;
    } catch (error) {
      console.error(
        "Failed to register Firebase service worker:",
        error
      );

      return null;
    }
  };

export const getFirebaseToken = async (): Promise<string | null> => {
  try {
    const messaging = await getFirebaseMessaging();

    if (!messaging) {
      return null;
    }

    const permissionGranted =
      await requestNotificationPermission();

    if (!permissionGranted) {
      console.warn(
        "Notification permission was not granted."
      );

      return null;
    }

    const serviceWorkerRegistration =
      await registerFirebaseServiceWorker();

    if (!serviceWorkerRegistration) {
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration,
    });

    if (!token) {
      console.warn("FCM token was not generated.");
      return null;
    }

    console.log("FCM token generated.");

    return token;
  } catch (error) {
    console.error(
      "Failed to generate Firebase token:",
      error
    );

    return null;
  }
};

export const subscribeToForegroundMessages = async (
  callback: (payload: MessagePayload) => void
) => {
  const messaging = await getFirebaseMessaging();

  if (!messaging) {
    return () => {};
  }

  return onMessage(messaging, callback);
};